import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthInput } from "../../../components/AuthInput/input";
import { YellowButton } from "../../../components/UI/Button/button";
import classes from "../index.module.css";
import { checkMail } from "../../../utils/functions";
import { postSupportComplaint as postTalentSupportComplaint } from "../../../services/talentCalls";
import { postSupportComplaint as postClientSupportComplaint } from "../../../services/clientCalls";
import confusedStan from "../../../assets/illustrations/approving-stan-blue.png";
import ErrorModal from "../../../layout/ErrorModal/ErrorModal";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";

const ReportBehavior = () => {
  const location = useLocation();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState({
    fname: "",
    "email/name": "",
    summaryOfReport: "",
    issue: "",
  });

  const getSupportType = () => {
    const pathname = location.pathname;
    if (pathname.includes("report-behaviour")) return "ReportBehavior";
    return "LogABug";
  };

  const isClient = location.pathname.includes("client");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const payload = {
        supportType: getSupportType(),
        fullName: data.fname,
        email: data["email/name"],
        summaryOfReport: data.summaryOfReport,
        message: data.issue,
      };
      if (isClient) {
        await postClientSupportComplaint(payload);
      } else {
        await postTalentSupportComplaint(payload);
      }
      setShowSuccessModal(true);
      setData({
        fname: "",
        "email/name": "",
        summaryOfReport: "",
        issue: "",
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const props1 = {
    type: "text",
    label: "Full Name*",
    placeholder: "Jane Doe",
    value: data.fname,
    onChange: (e) =>
      setData((prev) => ({
        ...prev,
        fname: e.target.value,
      })),
    isValid: data.fname?.length > 3,
    text: "Invalid Full Name",
    name: "Full Name",
    id: "fname",
  };

  const props2 = {
    type: "text",
    label: "Email Address*",
    placeholder: "Janedoe@awasource.com",
    value: data["email/name"],
    onChange: (e) =>
      setData((prev) => ({
        ...prev,
        "email/name": e.target.value,
      })),
    isValid: checkMail(data["email/name"]),
    text: "Invalid Email Address",
    name: "Email Address",
    id: "email",
  };

  const props5 = {
    type: "text",
    label: "Summary of Report*",
    placeholder: "",
    value: data.summaryOfReport,
    onChange: (e) =>
      setData((prev) => ({
        ...prev,
        summaryOfReport: e.target.value,
      })),
    isValid: data.summaryOfReport?.length > 3,
    text: "Invalid Report Summary",
    name: "Summary of Report",
    id: "summaryOfReport",
  };

  return (
    <div className={classes.main}>
      {isSubmitting && <FullScreenLoader />}
      <h3 className="t-24 mb-md">Report Behaviour</h3>
      <div>
        <form onSubmit={handleSubmit}>
          <p className="mb-md t-md">Report inappropriate behaviour</p>
          <AuthInput {...props1} />
          <AuthInput {...props2} />
          <AuthInput {...props5} />
          <label>Details of Issue*</label>
          <textarea
            style={{ resize: "none" }}
            placeholder=""
            value={data.issue}
            onChange={(e) =>
              setData((prev) => ({
                ...prev,
                issue: e.target.value,
              }))
            }
          ></textarea>
          <span className={classes.info}>
            Any information you provide is in accordance with our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link> &
            <Link to="/terms-of-service"> Terms of Use</Link>
          </span>
          <YellowButton
            disabled={
              !data.fname ||
              !checkMail(data["email/name"]) ||
              !data.summaryOfReport ||
              !data.issue ||
              isSubmitting
            }
            type="submit"
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </YellowButton>
        </form>
      </div>

      {showSuccessModal && (
        <ErrorModal
          isModalOpen={showSuccessModal}
          setModalOpen={setShowSuccessModal}
        >
          <div
            style={{
              backgroundColor: "#0A0F8F",
              padding: "50px 110px",
              borderRadius: "8px",
              textAlign: "center",
              color: "white",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <img
              src={confusedStan}
              alt="Success confirmation"
              style={{
                width: "150px",
                height: "auto",
                marginBottom: "20px",
              }}
            />
            <p
              style={{
                fontSize: "18px",
                marginBottom: "10px",
              }}
            >
              Thanks for your feedback
            </p>
            <p
              style={{
                fontSize: "14px",
                lineHeight: "1.5",
              }}
            >
              We will get back to you soon.
            </p>
          </div>
        </ErrorModal>
      )}
    </div>
  );
};

export default ReportBehavior;
